import { Dropdown } from 'legacy/lut/library/dropdown'
import { FC, useCallback, useMemo } from 'react'

import { Static } from 'core-components/types'
import { Crud } from 'core/types/Crud'

import { IFormJBPHPContactRoles } from '../../../../../../../classes/models/partner360/IFormHPContacts'

import styles from './PartnerRolesDropdown.module.scss'

interface IPartnerRolesDropdownProps {
  value?: string
  roles: IFormJBPHPContactRoles[]

  onRoleChange: (newRole: IFormJBPHPContactRoles) => void
}

export const PartnerRolesDropdown: FC<IPartnerRolesDropdownProps> = ({
  value = '',
  roles,

  onRoleChange,
}) => {
  const staticRolesCrud = useMemo(() => {
    return new Crud<IFormJBPHPContactRoles>({
      fetcher: new Static(roles),
      keyField: 'UniqueId',
      defaultPaging: {
        page: 0,
        pageSize: roles.length,
      },
    })
  }, [roles])

  const handleChangeRole = useCallback(
    (newValue: string) => {
      const role = roles.find((it) => it.UniqueId === newValue)

      if (role) {
        onRoleChange(role)
      }
    },
    [roles, onRoleChange]
  )

  return (
    <Dropdown
      classes={{
        controlClasses: {
          root: styles.dropdown,
        },
      }}
      value={value}
      source={staticRolesCrud}
      caption="Roles"
      label="Roles"
      onChange={handleChangeRole}
      translation="partnerContacts-roles"
    />
  )
}
